import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import AppNavbarLink from './app-navbar-link'
import type { NavbarSection } from '../../config/navbar-data'

interface MobileMenuSectionProps {
  sections: NavbarSection[]
  onItemClick?: () => void
  defaultOpen?: boolean
}

export default function MobileMenuSection({ sections, onItemClick, defaultOpen = false }: MobileMenuSectionProps) {
  const defaultValue = defaultOpen && sections.length > 0 ? [`section-0`] : []

  return (
    <div className="space-y-2">
      <Accordion type="multiple" defaultValue={defaultValue} className="w-full">
        {sections.map((section, index) => (
          <AccordionItem key={section.title} value={`section-${index}`}>
            <AccordionTrigger className="!text-muted-foreground hover:text-primary py-2 text-sm hover:no-underline pl-4">
              {section.title}
            </AccordionTrigger>
            <AccordionContent>
              <div className="space-y-1 pl-8">
                {section.items?.map(item => (
                  <AppNavbarLink
                    key={item.href}
                    href={item.href}
                    variant="menu-item"
                    onClick={onItemClick}
                  >
                    {item.title}
                  </AppNavbarLink>
                ))}
              </div>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  )
}
